import unauthenticatedApi from "@/utils/unauthenticatedAxios";

const ML_SEARCH_INTENT_PATH = "/public/ml/search-intent";
const DEFAULT_SMART_SEARCH_TIMEOUT_MS = 5000;

export interface SmartSearchIntentResponse {
  textQuery: string;
  categorySlugs: string[];
  regionKeys: string[];
  aiApplied: boolean;
  fallbackUsed: boolean;
}

const normalizeIntentResponse = (raw: any): SmartSearchIntentResponse => {
  const categorySlugs = Array.isArray(raw?.categorySlugs)
    ? raw.categorySlugs
        .map((value: unknown) => String(value ?? "").trim().toLowerCase())
        .filter((value: string) => value.length > 0)
    : [];
  const regionKeys = Array.isArray(raw?.regionKeys)
    ? raw.regionKeys
        .map((value: unknown) => String(value ?? "").trim())
        .filter((value: string) => value.length > 0)
    : [];

  return {
    textQuery: String(raw?.textQuery ?? "").trim(),
    categorySlugs: Array.from(new Set(categorySlugs)),
    regionKeys: Array.from(new Set(regionKeys)),
    aiApplied: Boolean(raw?.aiApplied),
    fallbackUsed: Boolean(raw?.fallbackUsed),
  };
};

export async function resolveSmartSearchIntent(
  query: string,
  lang: "de" | "en",
  timeoutMs = DEFAULT_SMART_SEARCH_TIMEOUT_MS
): Promise<SmartSearchIntentResponse> {
  const payload = { query, lang };

  const response = await unauthenticatedApi.post(
    ML_SEARCH_INTENT_PATH,
    payload,
    {
      headers: { "Content-Type": "application/json" },
      timeout: timeoutMs,
      validateStatus: (status) => status >= 200 && status < 300,
    }
  );
  return normalizeIntentResponse(response.data);
}
